import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  ScoutSetup,
} from '#features/scout/ScoutSetup';
export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/setup/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ScoutSetup />;
}
